import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  workflowID: ''
}

const workflowSlice = createSlice({
  name: 'workflow',
  initialState,
  reducers: {
    setWorkflowID: (state, action) => {
      state.workflowID = action.payload
    }
  }
})

export const { setWorkflowID } = workflowSlice.actions

export default workflowSlice.reducer